import React, { Fragment, useContext, useEffect, useState } from "react";

import { post } from 'axios';
// Provider
import { AppContext } from "../../../../../components/AppProvider";

// Utils
import { _O } from "../../../../../modules/utils";

// UI
import { IC, Doctor } from "../../../../../resources/Assets";
import { Container, DateLayer, DateTimeLayer, openLayerFn, closeLayerFn, pickerStart } from "../../../../Layout";
import { DoctorMessage } from "../../../SM.Layers";
import { ScrollToTop } from "../../../../common/ScrollToTop/ScrollToTop";

// Temp Images
import _T_MEAL from "../../../../../resources/images/user/user_meal_photo01.jpg";

import { SUBS, SubMenu } from "../../History";

export const MealDetailLayer = (props) => {
    return (
        <div className="blacklayer-container foodmenu-photo-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box wht vertical">
                        <div className="blgr-title">식단</div>
                        <p className="under-txt">2020.08.02.아침식단</p>

                        <div className="food-photo-area">
                            <img src={_T_MEAL} alt="" />
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gree">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};